module.exports = getResponse
function getResponse (opt, resp) {
  if (!resp) return null
  return {
    statusCode: resp.statusCode,
    headers: resp.headers,
    method: opt.method,
    url: opt.url,
    // the XHR object in browser, http response in Node
    rawRequest: resp.rawRequest ? resp.rawRequest : resp
  }
}



//////////////////
// WEBPACK FOOTER
// ./~/xhr-request/lib/normalize-response.js
// module id = 998
// module chunks = 0 1 2 3